<template>
  <div>
    <a-card class="antd-pro-pages-dashboard-analysis-salesCard" :style="{ height: '125px' }">
      <div class="dataWarp">
        <div class="dataItem">
          <span class="itemTop">
            {{headerList.num}}
            <span class="unit">个</span>
          </span>
          <span class="itemBottom">已监测贸易结算表个数</span>
        </div>

        <div class="dataItem">
          <span class="itemTop">
            {{headerList.waterSum}}
            <span class="unit">m³</span>
          </span>
          <span class="itemBottom">贸易结算表售水量总和（昨日）</span>
        </div>

        <div class="dataItem">
          <span class="itemTop">
            {{headerList.newNum}}
            <span class="unit">台</span>
          </span>
          <span class="itemBottom">本月新装贸易结算表数量</span>
        </div>
      </div>
    </a-card>
    <!-- 地图 -->
    <div style="height: 447px;width: 100%;margin-top:20px">
      <base-map ref="bigmap" code="remote_water_index_legend"  style="height: 447px;width: 100%;"/>
    </div>
    <!-- 底部 -->
  </div>
</template>

<script>
import iconRight from '@/assets/myImg/1/icon-right-circle.svg?inline'
import BaseMap from '@/views/sys/components/RemoteWaterMap'
import ClassifiedStatisticsEchart from './module/ClassifiedStatisticsEchart.vue'
import BarEchart from './module/BarEchart.vue'
export default {
  name: 'RemoteZoneMid',
  components: {
    iconRight,
    BaseMap,
    ClassifiedStatisticsEchart,
    BarEchart
  },
  data() {
    return {
      classDataList: {},
      waterList: {},
      headerList: {
        newNum: 30,
        num: 190,
        waterSum: '52254.01'
      }
    }
  },
  methods: {
    getList() {
      //头部数据
      this.$http.get('/pipe-network/remote_transmission_workbenchs/find/workbench').then(res => {
        // this.headerList = res.data
        console.log(res.data)
        this.headerList={
          waterSum: parseFloat(res.data.waterSupplySum).toFixed(2),
              newNum:  res.data.newThisMonth,
        num: res.data.waterNum ,
        }
      })

      //贸易结算表总供水量
      this.$http.get('/pipe-network/yc_user_remote_water_meters/settlement/total-supply').then(res => {
        
        let list = res.data
        var xdata = []
        var sdata = []
        list.map(item => {
          xdata.push(item.time)
          sdata.push(item.meterNumber)
        })
        this.waterList = {
          xdata: xdata,
          sdata: sdata,
          color: [
            new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: '#18B0DD' }, //柱图渐变色
              { offset: 1, color: '#2A80E8' } //柱图渐变色
            ])
          ],
          grid: {
            x: '12%', //左侧与y轴的距离
            // y:0, //top部与x轴的距离
            x2: '2%', //右侧与y轴的距离
            y2: '16%' //bottom部与x轴的距离
          }
        }
      })

    
    }
  },
  created() {
    this.getList()
  }
}
</script>
<style lang="less" scoped>
.radius {
  float: left;
  width: 6px;
  height: 21px;
  background: #0265ff;
  border-radius: 3px;
}
.radiusTitle {
  margin-left: 10px;
  float: left;
  width: 100px;
  height: 21px;
  line-height: 21px;
  font-family: MicrosoftYaHeiSemibold;
  font-size: 16px;
  color: #101010;
  letter-spacing: 0.63px;
  font-weight: 600;
}
.radioTitle {
  height: 29px;
  font-family: MicrosoftYaHeiSemibold;
  font-size: 14px;
  color: #101010;
  letter-spacing: 0.56px;
  font-weight: 600;
}
.dataWarp {
  padding: 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  .dataItem {
    display: flex;
    flex-direction: column;
    text-align: center;
    .itemTop {
      font-family: MicrosoftYaHeiSemibold;
      font-size: 24px;
      color: #2f54eb;
      letter-spacing: 0.13px;
      font-weight: 600;
      .unit {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #404549;
        letter-spacing: 0.08px;
        font-weight: 400;
      }
    }
    .itemBottom {
      font-family: MicrosoftYaHei;
      font-size: 14px;
      color: #404549;
      letter-spacing: 0.08px;
      font-weight: 400;
    }
  }
}
.waropBottom {
  display: flex;
  justify-content: space-between;
}
/deep/ .ant-card-body {
  padding: 0;
}
</style>
